import type { TimelineCard } from '../../games/playtest-sessions-data.js';

import { SessionDispatchCard } from './session-dispatch-card.js';
import { SessionEventCard } from './session-event-card.js';
import { SessionResponseCard } from './session-response-card.js';

interface Props {
  cards: TimelineCard[];
}

// Renders the merged session timeline. Cards land newest-first; we
// stamp a key from the card's payload so a realtime tick that adds a
// new event card doesn't shake the existing ones.
export function SessionTimeline({ cards }: Props): JSX.Element {
  return (
    <ul className="flex flex-col gap-2">
      {cards.map((card) => (
        <li key={cardKey(card)}>{renderCard(card)}</li>
      ))}
    </ul>
  );
}

function cardKey(card: TimelineCard): string {
  switch (card.kind) {
    case 'event':
      return `event:${card.eventLog.id}`;
    case 'dispatch':
      return `dispatch:${card.dispatch.id}`;
    case 'response':
      return `response:${card.feedbackPoolId}`;
  }
}

function renderCard(card: TimelineCard): JSX.Element {
  switch (card.kind) {
    case 'event':
      return <SessionEventCard card={card} />;
    case 'dispatch':
      return <SessionDispatchCard card={card} />;
    case 'response':
      return <SessionResponseCard card={card} />;
  }
}
